<template>
  <div class="h-screen pb-safe flex flex-col overflow-hidden">
    <simple-top-bar
      :show-close="isMobile ? showClose : false"
      :show-back="isMobile ? showBack : false"
      @close="$emit('close')"
      @back="$emit('back')"
    >
      <template v-if="!isMobile" #left>
        <div></div>
      </template>
      <template v-if="isMobile" #[mobileSlot]>
        <span class="heading-3">
          {{ title }}
        </span>
      </template>
      <template v-if="!isMobile" #center>
        <span class="heading-3">
          {{ title }}
        </span>
      </template>
      <template v-if="!isMobile" #right>
        <l-button
          v-if="showClose"
          size="medium"
          icon="close"
          type="text"
          color="white"
          @click="$emit('close')"
        />
        <span v-else />
      </template>
    </simple-top-bar>
    <div class="overflow-y-scroll scrolling-touch w-full h-full bg-content-background relative">
      <slot />
    </div>
    <div v-if="$slots.footer" class="p-4 pb-7 flex justify-center">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

import { LButton } from '@last/core-ui/paprika'

import SimpleTopBar from './SimpleTopBar.vue'

const props = withDefaults(
  defineProps<{
    title: string
    showBack?: boolean
    showClose?: boolean
  }>(),
  {
    showBack: false,
    showClose: true
  }
)

defineEmits<{
  close: []
  back: []
}>()

const mobileSlot = computed(() => (props.showBack ? 'center' : 'left'))

const isMobile = useBreakpoints(breakpointsTailwind).smallerOrEqual('sm')
</script>
